import { useQuery } from "react-query";
import { getAllMyndas } from "services/mynda.service";

export default function useMyndas(params?: {
  page?: number;
  limit?: number;
  search?: string;
  employeeType?: string;
}) {
  return useQuery(["myndas", params], () => getAllMyndas(params), {
    keepPreviousData: true,
  });
}
